import createHistory from 'history/createBrowserHistory'

export default createHistory()



// WEBPACK FOOTER //
// ./src/api/history.js